import { render, staticRenderFns } from "./SkillDialog.vue?vue&type=template&id=641358fe&scoped=true"
import script from "./SkillDialog.vue?vue&type=script&lang=js"
export * from "./SkillDialog.vue?vue&type=script&lang=js"
import style0 from "./SkillDialog.vue?vue&type=style&index=0&id=641358fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641358fe",
  null
  
)

export default component.exports